import React from "react";

const Avatar = React.forwardRef(function Avatar(
  { className = "", src, alt = "Avatar", ...props },
  ref,
) {
  const classes = ["inline-block rounded-full object-cover", className].filter(Boolean).join(" ");

  return <img ref={ref} src={src} alt={alt} className={classes} {...props} />;
});

export default Avatar;
